import React, { useState } from "react";
import "./../styles/Login.css";
import NavLogin from "./NavLogin";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2"; 
import { lupaSandi } from "../utils/api"; 
import axios from "axios"; 

const LupaSandi = () => {
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState(""); 
  const [token, setToken] = useState(""); 
  const [errors, setErrors] = useState({});
  const [showPasswordFields, setShowPasswordFields] = useState(false); 
  const [showChangePasswordButton, setShowChangePasswordButton] =
    useState(false); 
  const [isEmailSent, setIsEmailSent] = useState(false); 
  const navigate = useNavigate();

  const validateInputs = () => {
    const newErrors = {};

    // Validasi username
    if (!username.trim()) {
      newErrors.username = "Username harus diisi";
    } else if (username.length < 2 || username.length > 20) {
      newErrors.username = "Username harus 2-20 karakter";
    } else if (!/^[a-zA-Z0-9._-]+$/.test(username)) {
      newErrors.username =
        "Username hanya boleh mengandung huruf, angka, dan karakter ._-";
    }

    // Validasi new password (if it's visible)
    if (showPasswordFields && !newPassword.trim()) {
      newErrors.newPassword = "Password baru harus diisi";
    }

    // Validasi token (if it's visible)
    if (showPasswordFields && !token.trim()) {
      newErrors.token = "Token pemulihan harus diisi";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearInputs = () => {
    setUsername("");
    setNewPassword("");
    setToken("");
    setErrors({});
    setShowPasswordFields(false); // Hide the new password fields
    setShowChangePasswordButton(false); // Hide the "Ganti Password" button
    setIsEmailSent(false); // Reset the email sent flag
  };

  const requestPasswordReset = async () => {
    if (validateInputs()) {
      const payload = {
        username,
      };

      try {
        // Call lupaSandi function to trigger the password reset request
        const response = await lupaSandi(payload);

        // Display success notification
        Swal.fire("Berhasil!", response.message, "success");

        // After success, show the new password fields and the "Ganti Password" button
        setShowPasswordFields(true);
        setShowChangePasswordButton(true);
        setIsEmailSent(true); // Email has been sent successfully, hide "Kirim Email Pemulihan" button
      } catch (error) {
        // Display error notification
        Swal.fire(
          "Gagal!",
          error.message || "Username / Email tidak ditemukan",
          "error"
        );
      }
    }
  };

  const changePassword = async () => {
    if (validateInputs()) {
      const payload = {
        username,
        new_password: newPassword,
        token,
      };

      try {
        // Send request to change password
        const response = await axios.post(
          "https://c-greenproject.org:7500/change-password",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Display success notification
        Swal.fire("Berhasil!", response.data.message, "success");

        // Optionally, redirect to login page or another page after success
        navigate("/login");
      } catch (error) {
        // Display error notification
        Swal.fire(
          "Gagal!",
          error.response?.data?.message || "Gagal mengganti password",
          "error"
        );
      }
    }
  };

  return (
    <div className="login-body">
      <form onSubmit={(e) => e.preventDefault()}>
        <section
          className="section"
          style={{
            padding: "1rem",
            maxWidth: "750px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div>
            <NavLogin />
            <div className="container">
              <div className="box">
                <article className="media">
                  <div className="media-content">
                    <div className="content">
                      <h1 className="title">Lupa Sandi</h1>
                      <div className="field has-addons">
                        <div style={{ width: "100%" }}>
                          <label className="Username">Username</label>
                          <div className="control has-icons-left">
                            <input
                              id="input-username"
                              className={`input ${
                                errors.username ? "is-danger" : ""
                              }`}
                              type="text"
                              placeholder="Username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                            <span className="icon is-small is-left">
                              <i className="fa fa-user"></i>
                            </span>
                          </div>
                          {errors.username && (
                            <p className="help is-danger">{errors.username}</p>
                          )}
                        </div>
                      </div>
                      <p className="help" style={{ fontSize: "12px" }}>
                        Masukkan username yang terdaftar untuk menerima email
                        pemulihan.
                      </p>

                      {showPasswordFields && (
                        <div>
                          <div className="field">
                            <label htmlFor="token">Token Pemulihan</label>
                            <div className="control has-icons-left">
                              <input
                                id="input-token"
                                className={`input ${
                                  errors.token ? "is-danger" : ""
                                }`}
                                type="text"
                                placeholder="Token"
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                              />
                              <span className="icon is-small is-left">
                                <i className="fa fa-key"></i>
                              </span>
                            </div>
                            {errors.token && (
                              <p className="help is-danger">{errors.token}</p>
                            )}
                          </div>

                          <div className="field">
                            <label htmlFor="newPassword">Password Baru</label>
                            <div className="control has-icons-left">
                              <input
                                id="input-new-password"
                                className={`input ${
                                  errors.newPassword ? "is-danger" : ""
                                }`}
                                type="password"
                                placeholder="Password Baru"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                              />
                              <span className="icon is-small is-left">
                                <i className="fa fa-lock"></i>
                              </span>
                            </div>
                            {errors.newPassword && (
                              <p className="help is-danger">
                                {errors.newPassword}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        className="has-text-centered"
                        style={{ marginTop: "20px" }}
                      >
                        <nav className="level is-mobile">
                          <div className="level-left">
                            {!isEmailSent && (
                              <button
                                className="level-item button"
                                style={{
                                  backgroundColor: "#ff4500",
                                  color: "#ffffff",
                                  transition: "background-color 0.3s ease",
                                }}
                                onClick={requestPasswordReset}
                              >
                                Kirim Email Pemulihan
                              </button>
                            )}
                            {showChangePasswordButton && (
                              <button
                                className="level-item button"
                                style={{
                                  backgroundColor: "#ff4500",
                                  color: "#ffffff",
                                  transition: "background-color 0.3s ease",
                                }}
                                onClick={changePassword}
                              >
                                Ganti Password
                              </button>
                            )}
                          </div>
                        </nav>
                        <hr />
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
};

export default LupaSandi;
